import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Box } from "@material-ui/core";
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';

// TabPanel styling
function TabPanel({ children, value, index }) {
  return <div>{value === index && <Box>{children}</Box>}</div>;
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

/**
 * @Description this page Active Directory  Library's Unlock User  Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function UnlockUser({
  action,
  variables,
  setOpenVariable,
  variableRender,
}) {
  const { t } = useTranslation();
  const label = 'CONTENT.CONFIGURATION-FORM.ACTIVE-DIRECTORY.CREATE-USER.';
  const [value, setValue] = useState(0);

  useEffect(() => {
    if(!action.fields.filter){ 
      action.fields.filter = { value: 'username'}
    }
  },[action, variables])

  const handleChange = (newValue) => {
    if(newValue === 0){ 
      action.fields.filter.value = 'username';
    } else { action.fields.filter.value = 'logonname'; }
    setValue(newValue);
  };
  return (
    <div>
      <div className="form-element">
      <div className="condition-tabs">
          <button
            className={value === 0 ? 'condition-active' : ''}
            onClick={() => handleChange(0)}>
            {t(label + "USERNAME")}
          </button>
          <button
            className={value === 1 ? 'condition-active' : ''}
            onClick={() => handleChange(1)}>
            {t(label + "LOGON-NAME")}
          </button>
        </div>
        <TabPanel value={value} index={0}>
          <TextInput
            action={action}
            isRequired={false}
            inputName="userName"
            variables={variables}
            setOpenVariable={setOpenVariable}
            variableRender={variableRender}
            fieldType="string"
            displayName={t(label + "USERNAME")}
          />
          <small style={{color:"var(--celeste)"}}>{"{eg:JohnBrown }"}</small>
        </TabPanel>
        <TabPanel value={value} index={1}>
          <TextInput
            action={action}
            isRequired={false}
            inputName="logonName"
            variables={variables}
            setOpenVariable={setOpenVariable}
            variableRender={variableRender}
            fieldType="string"
            displayName={t(label + "LOGON-NAME")}
          />
          <small style={{color:"var(--celeste)"}}>{"{eg:johnbrown }"}</small>
        </TabPanel>
      </div>
    </div>
  );
}
